function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Styles
import "../../../src/components/VSheet/VSheet.sass"; // Mixins

import Colorable from "../../mixins/colorable";
import Elevatable from "../../mixins/elevatable";
import Measurable from "../../mixins/measurable";
import Themeable from "../../mixins/themeable"; // Helpers

import mixins from "../../util/mixins";
/* @vue/component */

export default mixins(Colorable, Elevatable, Measurable, Themeable).extend({
  name: 'v-sheet',
  props: {
    tag: {
      type: String,
      "default": 'div'
    },
    tile: Boolean
  },
  computed: {
    classes: function classes() {
      return _objectSpread({
        'v-sheet': true,
        'v-sheet--tile': this.tile
      }, this.themeClasses, {}, this.elevationClasses);
    },
    styles: function styles() {
      return this.measurableStyles;
    }
  },
  render: function render(h) {
    var data = {
      "class": this.classes,
      style: this.styles,
      on: this.$listeners
    };
    return h(this.tag, this.setBackgroundColor(this.color, data), this.$slots["default"]);
  }
});